export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";